import SelectSearchalityVersion from './SelectSearchalityVersion.component';

export default SelectSearchalityVersion;